module.exports = __webpack_public_path__ + "img/telling-logo-white.ed32151e.png";